// 110 years back
export const birthDateMax = new Date(new Date().setFullYear(new Date().getFullYear() - 110));

// 15v years in future
export const passportExpiryMax = new Date(new Date().setFullYear(new Date().getFullYear() + 15));

// if date is default server value, return new instance, else return the instance parsed from string passed in
export const newDateIfDefault = (stringDate) => {
  if (stringDate && stringDate !== '0001-01-01T00:00:00') {
    return new Date(stringDate);
  }
  return '';
};

export const composeIsoString = (day, month, year) => {
  //js date months are 0 based, so need to add 1 for ISO
  if (month) {
    month = (+month + 1).toString();
  }
  return `${year}-${month?.padStart(2, '0')}-${day?.padStart(2, '0')}`;
};
